// 运营平台路由注册表：仅保留当前系统菜单及基础功能所需路由
import operationsRouteList from './operationsRouterMap';
import LZLayout from '../pages/base/Layout';
import Login from '../pages/base/Login';
import LoginVerify from '../pages/base/LoginVerify';
import Reset from '../pages/base/Reset';
import ShopSelect from '../pages/base/ShopSelect';
import SystemEntry from '../pages/base/SystemEntry';
import Validation from '../pages/base/Validation';
import FeatureViewStatistics from '../pages/dataStatistics/dataStatistics/featureView';
import IntegralMallHead from '../pages/decorationManage/pageDecor/integralMallHead';
import PageConfig from '../pages/decorationManage/pageDecor/pageConfig';
import HomePage from '../pages/Home/HomePage/page';
import MemberDetail from '../pages/memberManagement/MemberManagement/MemberDetail';
import MemberList from '../pages/memberManagement/MemberManagement/MemberList';
import BenefitsManagement from '../pages/memberManagement/membershipBenefits/benefitsManagement';
import EquityDistributionRecord from '../pages/memberManagement/membershipBenefits/equityDistributionRecord';
import MembershipLevelBenefits from '../pages/memberManagement/membershipBenefits/membershipLevelBenefits';
import ShopBenefitsManagement from '../pages/memberManagement/membershipBenefits/shopBenefitsManagement';
import UserInfoEdit from '../pages/PersonalCenter/EditUserInfo';
import BreedManage from '../pages/petManage/infoConfig/breedManage';
import LifeStageManage from '../pages/petManage/infoConfig/lifeStageManage';
import TagManage from '../pages/petManage/infoConfig/tagManage';
import PetList from '../pages/petManage/petManageChild/petList';
import AssetManageGoods from '../pages/pointCenter/assetManage/goods';
import StoreCoupon from '../pages/pointCenter/assetManage/storeCoupon';
import GoodsRecommendList from '../pages/petManage/goodsRecommend/goodsRecommendList';
import CategoryManage from '../pages/pointCenter/mallConfig/categoryManage';
import ExchangeConfig from '../pages/pointCenter/mallConfig/exchangeConfig';
import EcExchangeConfig from '../pages/pointCenter/mallConfig/ecExchangeConfig';
import OrderList from '../pages/pointCenter/orderManage/orderList';
import ReissueThirdCoupon from '../pages/pointCenter/orderManage/reissueThirdCoupon';
import AccountManagement from '../pages/SystemSettingManagement/AccountAuthority/AccountManagement';
import RoleManagement from '../pages/SystemSettingManagement/AccountAuthority/RoleManagement';
import TermsConditions from '../pages/SystemSettingManagement/SystemSetting/termsConditions';
import ActivityList from '../pages/ActivityManage/ActivityList';
import TrackConfig from '../pages/ActivityManage/TrackConfig';
import TrackData from '../pages/ActivityManage/TrackData';
import TrackBoard from '../pages/ActivityManage/TrackBoard';

const routeList = [
  { path: '/', name: 'main', component: <LZLayout />, auth: true, layout: true },

  { path: '/login', name: 'Login', component: <Login />, auth: false, layout: false },

  { path: '/loginVerify', name: 'LoginVerify', component: <LoginVerify />, auth: false, layout: false },

  { path: '/validation', name: 'Validation', component: <Validation />, auth: false, layout: false },

  { path: '/reset', name: 'Reset', component: <Reset />, auth: false, layout: false },

  { path: '/systemEntry', name: 'SystemEntry', component: <SystemEntry />, auth: false, layout: false },

  { path: '/shopSelect', name: 'ShopSelect', component: <ShopSelect />, auth: false, layout: false },

  {
    path: '/memberManagement/memberManagement/memberList',
    name: 'MemberList',
    component: <MemberList />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/memberManagement/memberManagement/memberDetail',
    name: 'MemberDetail',
    component: <MemberDetail />,
    auth: true,
    layout: false,
    menu: false,
  },

  {
    path: '/memberManagement/membershipBenefits/benefitsManagement',
    name: 'BenefitsManagement',
    component: <BenefitsManagement />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/memberManagement/membershipBenefits/shopBenefitsManagement',
    name: 'ShopBenefitsManagement',
    component: <ShopBenefitsManagement />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/memberManagement/membershipBenefits/membershipLevelBenefits',
    name: 'MembershipLevelBenefits',
    component: <MembershipLevelBenefits />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/memberManagement/membershipBenefits/equityDistributionRecord',
    name: 'EquityDistributionRecord',
    component: <EquityDistributionRecord />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/petManage/goodsRecommend/goodsRecommendList',
    name: 'GoodsRecommendList',
    component: <GoodsRecommendList />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/pointCenter/assetManage/goods',
    name: 'AssetManageGoods',
    component: <AssetManageGoods />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/pointCenter/assetManage/storeCoupon',
    name: 'StoreCoupon',
    component: <StoreCoupon />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/pointCenter/mallConfig/exchangeConfig',
    name: 'ExchangeConfig',
    component: <ExchangeConfig />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/pointCenter/mallConfig/ecExchangeConfig',
    name: 'EcExchangeConfig',
    component: <EcExchangeConfig />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/pointCenter/mallConfig/categoryManage',
    name: 'CategoryManage',
    component: <CategoryManage />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/pointCenter/orderManage/orderList',
    name: 'OrderList',
    component: <OrderList />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/pointCenter/orderManage/reissueThirdCoupon',
    name: 'ReissueThirdCoupon',
    component: <ReissueThirdCoupon />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/petManage/petManageChild/petList',
    name: 'PetList',
    component: <PetList />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/petManage/infoConfig/breedManage',
    name: 'BreedManage',
    component: <BreedManage />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/petManage/infoConfig/lifeStageManage',
    name: 'LifeStageManage',
    component: <LifeStageManage />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/petManage/infoConfig/tagManage',
    name: 'TagManage',
    component: <TagManage />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/decorationManage/pageDecor/integralMallHead',
    name: 'IntegralMallHead',
    component: <IntegralMallHead />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/decorationManage/pageDecor/pageConfig',
    name: 'PageConfig',
    component: <PageConfig />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/dataStatistics/dataStatistics/featureView',
    name: 'FeatureViewStatistics',
    component: <FeatureViewStatistics />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/systemSettingManagement/accountAuthority/accountManagement',
    name: 'AccountManagement',
    component: <AccountManagement />,
    auth: true,
    layout: true,
    menu: true,
  },

  { path: '/home/homePage/page', name: 'home', component: <HomePage />, auth: true, layout: true, menu: true },

  { path: '/userInfoEdit', name: 'UserInfoEdit', component: <UserInfoEdit />, auth: true, layout: false },

  {
    path: '/systemSettingManagement/accountAuthority/roleManagement',
    name: 'RoleManagement',
    component: <RoleManagement />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/systemSettingManagement/systemSetting/termsConditions',
    name: 'TermsConditions',
    component: <TermsConditions />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/activityManage/activityManage/activityList',
    name: 'ActivityList',
    component: <ActivityList />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/activityManage/activityManage/trackConfig',
    name: 'TrackConfig',
    component: <TrackConfig />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/activityManage/activityManage/activityList/trackData',
    name: 'trackData',
    component: <TrackData />,
    auth: true,
    layout: true,
    menu: true,
  },

  {
    path: '/activityManage/activityManage/trackBoard',
    name: 'TrackBoard',
    component: <TrackBoard />,
    auth: true,
    layout: true,
    menu: true,
  },
  ...operationsRouteList,
];

export default routeList;
